// extracted by mini-css-extract-plugin
module.exports = {"totalUnpaid":"Invoices_totalUnpaid_wS9Pb","filterGroup":"Invoices_filterGroup_oVYkm","filterLabel":"Invoices_filterLabel_2-oDt","filterFooter":"Invoices_filterFooter_6NuId"};